<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      View Raw Data
      <div slot="right" class="navbar-message button-gap-right-aligned">
        <div class="hero-navbar-right-flex">
          <b-button
            type="is-normal"
            class="import-button"
            @click="backToImport"
          >
            Back</b-button
          >
          <b-button
            type="is-primary"
            class="import-button"
            @click="isCardModalActive = true"
            v-if="
              (checkCurrentStatus('In Validation') ||
                checkCurrentStatus('Merging Failed') ||
                checkCurrentStatus('Complete')) &&
                isEditAllowed
            "
          >
            Update Status</b-button
          >
        </div>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <section class="has-listing-table validation-collapse">
        <div class="level no-margin">
          <div
            class="level-left validation-collapse-header-text"
            @click="togglePanel"
          >
            <h3 class="import-type-name">
              General Import Information ({{ importData.customer_name }})
            </h3>
            <b-icon :icon="isOpen ? 'chevron-up' : 'chevron-down'"></b-icon>
          </div>

          <div class="level-right validation-toggole-level">
            <span>Current Status:</span><span> &nbsp;</span>
            &nbsp;
            <b-icon
              icon="timer-sand"
              v-if="checkCurrentStatus('In Validation')"
              custom-size="default"
            ></b-icon>
            <b-icon
              icon="alert-circle"
              v-if="checkCurrentStatus('Failed')"
              custom-size="default"
              type="is-danger"
            ></b-icon>
            <b-icon
              icon="check-all"
              v-if="checkCurrentStatus('Completed and Validated')"
              custom-size="default"
              type="is-success"
            ></b-icon>
            <b-icon
              icon="check"
              v-if="checkCurrentStatus('Complete')"
              custom-size="default"
              type="is-success"
            ></b-icon>
            <span>{{ importData.status }}</span>
          </div>
        </div>
        <b-collapse class="validation-panel" animation="slide" :open="isOpen">
          <div class="card validation-card">
            <div class="card-content">
              <div class="columns">
                <div class="column columns no-margin">
                  <div class="column icon-column">
                    <b-icon icon="account-circle"></b-icon>
                  </div>
                  <div class="column is-three-quarters">
                    <div class="columns validation-text-header">
                      Customer Name
                    </div>
                    <div class="columns">
                      <h3 class="no-padding">{{ importData.customer_name }}</h3>
                    </div>
                  </div>
                </div>
                <div class="column columns no-margin">
                  <div class="column icon-column">
                    <b-icon icon="calendar-blank-outline"></b-icon>
                  </div>
                  <div class="column is-three-quarters">
                    <div class="columns validation-text-header">
                      Import Type
                    </div>
                    <div class="columns">
                      <h3 class="no-padding">{{ importData.import_type }}</h3>
                    </div>
                  </div>
                </div>
                <div class="column columns no-margin">
                  <div class="column icon-column">
                    <b-icon icon="account"></b-icon>
                  </div>
                  <div class="column is-three-quarters">
                    <div class="columns validation-text-header">
                      Imported By
                    </div>
                    <div class="columns">
                      <h3 class="no-padding">
                        {{ importData.imported_by_user }}
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="column columns no-margin">
                  <div class="column icon-column">
                    <b-icon icon="account"></b-icon>
                  </div>
                  <div class="column is-three-quarters">
                    <div class="columns validation-text-header">
                      Imported At
                    </div>
                    <div class="columns">
                      <h3 class="no-padding">
                        {{ importData.created_at_formatted }}
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="column columns no-margin">
                  <div class="column icon-column">
                    <b-icon icon="notebook"></b-icon>
                  </div>
                  <div class="column is-three-quarters">
                    <div class="columns no-padding validation-text-header">
                      Comment
                    </div>
                    <div class="columns">
                      <a
                        ref="#"
                        @click.prevent="showComments(importData.comment)"
                        ><h3 class="no-padding validation-import-comments">
                          See Comments
                        </h3></a
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="column columns no-margin"
                  v-if="importData.import_type != 'Products'"
                >
                  <div class="column icon-column">
                    <b-icon icon="calendar-clock"></b-icon>
                  </div>
                  <div class="column is-three-quarters">
                    <div class="columns no-padding validation-text-header">
                      Period
                    </div>
                    <div class="columns">
                      <h3 class="no-padding">{{ importData.period }}</h3>
                    </div>
                  </div>
                </div>
                <div class="column columns no-margin" v-else></div>
              </div>
              <div class="columns">
                <div class="column columns no-margin">
                  <div class="column icon-column">
                    <b-icon icon="notebook"></b-icon>
                  </div>
                  <div class="column is-three-quarters">
                    <div class="columns no-padding validation-text-header">
                      Attached Documents
                    </div>
                    <div class="columns">
                      <a ref="#" @click.prevent="isFileListActive = true"
                        ><h3 class="no-padding validation-import-comments">
                          See Lists
                        </h3></a
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="column columns no-margin"
                  v-if="
                    this.importType == 'Products' &&
                      checkCurrentStatus('Partial Import') &&
                      !isViewOnly
                  "
                >
                  <div class="column icon-column">
                    <b-icon icon="account"></b-icon>
                  </div>
                  <div class="column is-three-quarters">
                    <div class="columns no-padding validation-text-header">
                      Data
                    </div>
                    <div class="columns">
                      <a ref="#" @click.prevent="isNewDataFileListActive = true"
                        ><h3 class="no-padding validation-import-comments">
                          Add data
                        </h3></a
                      >
                    </div>
                  </div>
                </div>
                <div class="column columns no-margin" v-else></div>
                <div class="column columns no-margin"></div>
                <div class="column columns no-margin"></div>
                <div class="column columns no-margin"></div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <section
        class="has-listing-table"
        v-if="!checkCurrentStatus('Completed and Validated')"
      >
        <div class="level no-margin">
          <div class="level-left">
            <!-- <h3 class="import-type-name">{{ importData.import_type }}</h3> -->

            <div
              class="navbar-item margin-top-bulk-edit no-padding"
              v-if="isEditAllowed"
            >
              <a @click="mapColumns()" data-cy="pd-bulk-edit">Map Columns </a>
            </div>
            <div class="navbar-item margin-top-bulk-edit" v-if="isEditAllowed">
              <a @click="dataManupulation()" data-cy="pd-bulk-edit">
                Data Manipulation</a
              >
            </div>
            <div class="navbar-item margin-top-bulk-edit">
              <b-switch
                v-model="suppressColumnView"
                @input="showSuppressColumn()"
                type="is-info"
              >
                <span style="padding-left: 5px;">Suppress column view</span>
              </b-switch>
            </div>
          </div>
          <div class="level-right page-configs">
            <b-field>
              <b-select
                placeholder="Please Select"
                expanded
                @input="changeDocument($event)"
                v-model="documentSelected"
              >
                <option
                  v-for="(option, index) in allDocumnets"
                  :value="option"
                  :key="index"
                >
                  {{ option.document_name }}
                </option>
              </b-select>
            </b-field>

            <!-- Column Configuration Dropdown -->
            <b-dropdown position="is-bottom-left" style="margin-bottom: 10px;">
              <template #trigger>
                <a class="navbar-item navbar-mdi-tune-dropdown">
                  <button class="button" data-cy="viewraw-config-button">
                    <span class="mdi mdi-table-cog mdi-24px mdi-dark"></span>
                  </button>
                </a>
              </template>
              <form>
                <div class="filter-config-modal-body">
                  <section class="filter-config-list">
                    <span>
                      <b-field label="Column Configuration"></b-field>
                    </span>
                    <div style="padding: 4px 0;">
                      <b-checkbox v-model="selectAll" @input="toggleSelectAll">
                        <strong>Select All</strong>
                      </b-checkbox>
                    </div>
                    <div
                      v-for="(column, index) in columns"
                      :key="index"
                      class="control"
                    >
                      <div
                        v-if="column.label != '' && column.field !== 'actions'"
                      >
                        <b-dropdown-item
                          aria-role="list"
                          :focusable="false"
                          custom
                          paddingless
                        >
                          <b-checkbox
                            @input="saveFieldConfig()"
                            v-model="column.visible"
                          >
                            <span v-html="column.label || ''"></span>
                          </b-checkbox>
                        </b-dropdown-item>
                      </div>
                    </div>
                  </section>
                </div>
              </form>
            </b-dropdown>
          </div>
        </div>
        <div class="enable-select-text" v-if="this.columns.length > 0">
          <circul8-table
            ref="circul8Table"
            @clickcheck="checkCheckBox"
            @checkedAll="checkedAllData"
            :checkedRows="checkedRow"
            :records="tableData"
            :fields="columns.filter(col => col.visible !== false)"
            :usePropRecords="true"
            :listingComponent="true"
            :isCheckable="false"
            :showEditButton="false"
            :showViewButton="false"
            :maxTextLength="'24'"
            :isLoading="isDataLoading"
            :hasNextData="nextData"
            :enableInfiniteScroll="true"
            @loadNextPage="pullNextPage"
            :hasPreviousData="previousData"
            @loadPreviousPage="pullPreviousPage"
            @querySet="searchByFilter"
            :backendSortingEnabled="true"
            @backendSort="sortData"
            @clickEdit="editModal"
            @clickView="viewModal"
            :enableSwitchAction="true"
            :routeNext="false"
            :allProductFamily="productFamily"
            :allMaterialDetail="materialDetail"
          />
          <div class="records-displayed" v-if="totalRecords > 0">
            <span v-if="isCheckedAll"> All selected, </span>
            <span v-if="checkedData.length > 0 && !isCheckedAll"
              >{{ checkedData.length }} selected,
            </span>
            <span v-if="currentPage * 50 + 50 < totalRecords"
              >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
              {{
                currentPage > 0
                  ? nextPageCursor
                    ? currentPage * 50 - 50 + tableData.length
                    : totalRecords
                  : tableData.length
              }}
              records out of {{ totalRecords }} records</span
            >
            <div v-else>
              <span v-if="currentPage == 0">
                displaying 0 - {{ totalRecords }} records out of
                {{ totalRecords }} records
              </span>
              <span v-else>
                displaying {{ currentPage * 50 - 50 }} -
                {{ totalRecords }} records out of {{ totalRecords }} records
              </span>
            </div>
          </div>
        </div>
      </section>
    </section>
    <b-modal v-model="isCardModalActive" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title title-success">Update Status</p>
        </header>
        <section class="modal-card-body">
          <b-field
            label="Please select a status"
            v-if="checkCurrentStatus('Partial Import')"
          >
            <b-select expanded v-model="tempWorkflowStatus">
              <option
                v-for="(option, index) in importWorkFlowPartialStatus"
                :value="option"
                :key="index"
                selected
              >
                {{ option }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Please select a status" v-else>
            <b-select expanded v-model="tempWorkflowStatus">
              <option
                v-for="(option, index) in importWorkFlowStatus"
                :value="option"
                :key="index"
                selected
              >
                {{ option }}
              </option>
            </b-select>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button
            label="Cancel"
            class="is-normal"
            @click="isCardModalActive = false"
          />
          <b-button label="Apply" type="is-primary" @click="tempStatusChange" />
        </footer>
      </div>
    </b-modal>
    <b-modal v-model="isFileListActive" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title title-success">Attached Documents</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Documents">
            <div class="tags">
              <span
                v-for="(file, index) in importData.documents"
                :key="index"
                class="tag"
                @click.prevent="downloadContent(file)"
                ><a href="#"
                  >{{ getFileName(file.document) }}
                  <i class="mdi mdi-download"></i
                ></a>
              </span>
            </div>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button
            label="Cancel"
            class="is-normal"
            @click="isFileListActive = false"
          />
        </footer>
      </div>
    </b-modal>
    <b-modal v-model="isNewDataFileListActive" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title title-success">Attached Documents</p>
        </header>
        <section class="modal-card-body">
          <form @submit.prevent="submit">
            <div class="columns no-margin-bottom">
              <section>
                <p>
                  Please upload only Error Document with corrected data related
                  to this import
                </p>
                <b-field
                  label="Choose a document to attach (CSV, XLSX or XLS)*"
                ></b-field>
                <b-field required class="file is-primary">
                  <b-upload
                    required
                    v-model="addDataDocument"
                    class="file-label"
                    multiple
                    drag-drop
                  >
                    <span>
                      <section class="section">
                        <div class="content has-text-centered">
                          <p>
                            <b-icon icon="upload" size="is-large"> </b-icon>
                          </p>
                          <p>Drop your files here or click to upload</p>
                        </div>
                      </section>
                    </span>
                  </b-upload>
                </b-field>
                <div class="tags">
                  <span
                    v-for="(file, index) in addDataDocument"
                    :key="index"
                    class="tag is-primary"
                  >
                    {{ file.name }}
                    <button
                      class="delete is-small"
                      type="button"
                      @click="deleteFile(index)"
                    ></button>
                  </span>
                </div>
              </section>
            </div>
            <div class="columns"></div>
          </form>
        </section>
      </div>
      <footer class="modal-card-foot">
        <b-button
          label="Cancel"
          class="is-normal"
          @click="isNewDataFileListActive = false"
        />
        <b-button label="Apply" type="is-primary" @click="submit" />
      </footer>
    </b-modal>
    <b-modal has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title title-success">Load data</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Documents">
            <div class="tags">
              <span
                v-for="(file, index) in importData.cdf_document_all"
                :key="index"
                class="tag"
                @click.prevent="downloadContent(file)"
                ><a href="#"
                  >{{ getFileName(file.document) }}
                  <i class="mdi mdi-download"></i
                ></a>
              </span>
            </div>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button
            label="Loads"
            class="is-normal"
            @click="isFileListActive = false"
          />
        </footer>
      </div>
    </b-modal>
    <single-product-edit
      :is-active="isModalActive"
      :customer-id="Number(this.customer_id)"
      :action="action"
      :edit-object-name="editObject"
      @confirm="editConfirm"
      @cancel="editCancel"
      :columns="this.columns"
      @updateSingleData="updatedSingleProduct"
      :allProductFamily="productFamily"
      :allMaterialDetail="materialDetail"
      :columnsConfig="this.cdf_product_config_sheet"
      :suppressColumnView="suppressColumnView"
      :key="'single-product-edit-' + columnsKey"
    />
    <bulk-product-edit
      v-if="importData.import_type == 'Products'"
      :is-active="isCardModalBulkEditActive"
      :customer-id="Number(this.customer_id)"
      @cancel="editBulkCancel"
      :columns="this.columns"
      :columnsConfig="this.cdf_product_config_sheet"
      :checkedRows="this.checkedRow"
      :isCheckedAllRows="this.isCheckedAll"
      :stream="this.stream"
      :tempProduct="true"
      @reload="reloadProductData"
      :query="this.query"
      :key="'bulk-product-edit-' + columnsKey"
    />
    <bulk-product-export
      @confirm="viewConfirmExport"
      @cancel="viewCancel"
      :is-active="isBulkExportModal"
      :key="'bulk-product-export-' + columnsKey"
    >
    </bulk-product-export>
    <data-completion
      :columns="this.columns"
      :columnsConfig="this.cdf_product_sheet"
      :checkedRows="this.checkedRow"
      :isCheckedAllRows="this.isCheckedAll"
      :stream="this.stream"
      :tempProduct="true"
      @reload="reloadProductData"
      :query="this.query"
      :customer-id="importData.customer"
      :is-active="isDataCompletion"
      @cancel="dataCompletionCancel"
      :key="'data-completion-' + columnsKey"
    >
    </data-completion>
    <map-columns
      :is-active="isMapColumnsActive"
      :customer-id="Number(this.customer_id)"
      @cancel="isMapColumnsActive = false"
      @updateMapColumns="updateMapColumns"
      :columns="this.columns"
      :columnsConfig="this.cdf_product_sheet"
      :checkedRows="this.checkedRow"
      :tableData="this.tableData"
      :isCheckedAllRows="this.isCheckedAll"
      :stream="this.stream"
      :importType="this.importData.import_type"
      :tempProduct="true"
      :documentSelected="documentSelected"
      @reload="reloadProductData"
      :suppressColumnView="suppressColumnView"
      :key="'map-columns-' + columnsKey"
    >
    </map-columns>
    <data-manipulation
      :is-active="isDataManupulationActive"
      :customer-id="Number(this.customer_id)"
      @cancel="isDataManupulationActive = false"
      :columns="fileHeaderColumns"
      :columnsConfig="this.cdf_product_sheet"
      :checkedRows="this.checkedRow"
      :isCheckedAllRows="this.isCheckedAll"
      :stream="this.stream"
      :tempProduct="true"
      :documentSelected="documentSelected"
      @updateColumns="updateColumnWithDataManipulation"
      @reload="reloadProductData"
      :key="'data-manipulation-' + columnsKey"
    >
    </data-manipulation>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import CDFProductDataService from "../../services/CDFProductDataService";
import CDFTransactionDataService from "../../services/CDFTransactionDataService";
import DataManagementService from "../../services/DataManagementImportService";
import Circul8Table from "../../components/Circul8Table.vue";
import { ImportCDFWorkflowStatus } from "../../constants/ImportCDFWorkflowStatus";
import SingleProductEdit from "@/components/DataManagement/SingleProductEdit";
import BulkProductEdit from "@/components/DataManagement/BulkProductEdit";
import BulkProductExport from "@/components/DataManagement/BulkProductExport.vue";
import MapColumns from "@/components/DataManagement/MapColumns.vue";
import DataManipulation from "@/components/DataManagement/DataManipulation.vue";
import DataCompletion from "@/components/DataManagement/DataCompletion.vue";
import { UserGroup } from "@/services/UserGroups";
import { mapGetters } from "vuex";
import UtilityMixin from "@/mixins/UtilityMixin";
import ProductMixin from "@/mixins/ProductMixin";
import ErrorMixin from "@/mixins/ErrorMixin";
let screenPixelSize;
let pixelRatio;
export default {
  name: "DataManagementValidation",
  mixins: [UtilityMixin, ProductMixin, ErrorMixin],
  components: {
    HeroBar,
    TitleBar,
    Circul8Table,
    BulkProductEdit,
    MapColumns,
    SingleProductEdit,
    BulkProductExport,
    DataCompletion,
    DataManipulation
  },
  data() {
    return {
      suppressColumnView: false,
      allDocumnets: [],
      documentSelected: null,
      checkEnableButton: true,
      checkedData: [],
      checkedRow: [],
      map1: new Map(),
      isCheckedAll: false,
      checkedDataMap: new Map(),
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      tblName: "Validation",
      fileHeaderColumns: [],
      totalRecords: 0,
      isBulkExportModal: false,
      isLoading: false,
      nextData: false,
      previousData: false,
      currentPage: 0,
      query: "",
      isDataLoading: false,
      isCardModalActive: false,
      isCardModalBulkEditActive: false,
      isMapColumnsActive: false,
      isDataManupulationActive: false,
      isFileListActive: false,
      isNewDataFileListActive: false,
      tempWorkflowStatus: null,
      importData: [],
      addDataDocument: [],
      isOpen: true,
      stream: "PRODUCT SHEET",
      availableStream: {},
      cdf_product_sheet: [],
      cdf_product_config_sheet: [],
      customer_id: "",
      parent_customer_id: null,
      tableData: [],
      customerDataService: new CustomerProfileDataService(),
      CDFProductDataService: new CDFProductDataService(),
      CDFTransactionDataService: new CDFTransactionDataService(),
      DataManagementService: new DataManagementService(),
      importId: this.$route.params.id,
      url: window.location.href,
      columns: [],
      importWorkFlowStatus: [
        ImportCDFWorkflowStatus.COMPLETED_AND_VALIDATED,
        ImportCDFWorkflowStatus.DISCARDED
      ],
      importWorkFlowPartialStatus: [ImportCDFWorkflowStatus.DISCARDED],
      currentStatus: this.$route.params.row?.status,
      isModalActive: false,
      editObject: {},
      action: "",
      selectAll: true,
      productFamily: {},
      materialDetail: {},
      subHeight: 355,
      dataValidationDropDownTD: [],
      dataValidationDropDownPD: [],
      productFamilyDropDown: [],
      productGroupDropDown: [],
      materialDetailDropDown: [],
      materialGeneralDropdown: [],
      packagingTypeDropDown: [],
      chemistryDropDown: [],
      exportLargeCount: 65000,
      isDataCompletion: false,
      isRawImport: true,
      columnsKey: 0
    };
  },
  computed: {
    importType() {
      if (this.importId && this.url.includes("/product")) {
        return "Products";
      } else {
        return "Transactions";
      }
    },
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"]),
    isEditAllowed() {
      if (
        this.userGroups.includes(UserGroup.EPR_ADMIN) ||
        // this.userGroups.includes(UserGroup.REPORTING_RESPONSIBLE)
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        return true;
      } else {
        return false;
      }
    },
    isViewOnly() {
      if (
        this.userGroups.includes(UserGroup.VIEW_ONLY) //||
        // this.userGroups.includes(UserGroup.REPORTING_RESPONSIBLE) ||
        // this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        return true;
      } else {
        return false;
      }
    },
    titleStack() {
      return [
        { url: "#", name: "Data Management" },
        { url: "/datamangement/import", name: "Import Raw Data" },
        { url: "#", name: "View Raw Data" }
      ];
    }
  },
  watch: {
    columns: {
      handler(newColumns) {
        // Only consider columns except 'actions'
        const visibleCols = newColumns.filter(col => col.field !== "actions");
        this.selectAll =
          visibleCols.length > 0 &&
          visibleCols.every(col => col.visible !== false);
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.checkExternalPermission();
    this.fetchRawImportDataById();

    // Watch for columns to initialize their visibility when they become available
    this.$watch(
      "columns",
      function(newColumns) {
        if (newColumns && newColumns.length > 0 && this.customer_id) {
          // Set all columns to visible by default
          // This is a failsafe in case prepareColumns doesn't set visibility correctly
          newColumns.forEach(col => {
            // Make sure actions column is always visible
            if (col.field === "actions") {
              col.visible = true;
            }
            // If visibility is not already set, default to true
            else if (col.visible === undefined) {
              col.visible = true;
            }
          });

          // Force update to ensure changes are rendered
          if (this.$refs.circul8Table) {
            this.$nextTick(() => {
              this.$refs.circul8Table.$forceUpdate();
            });
          }
        }
      },
      { immediate: true }
    );

    if (this.$route.params.customer) {
      this.form.customer = this.$route.params.customer;
    }
    if (this.$route.params.importType) {
      this.form.importType = this.$route.params.importType;
    }
  },
  methods: {
    toggleSelectAll() {
      // Toggle all columns except 'actions'
      const updated = this.columns.map(col => {
        if (col.field !== "actions") {
          return { ...col, visible: this.selectAll };
        }
        return col;
      });
      this.columns = updated;
      this.saveFieldConfig();
    },
    showSuppressColumn() {
      this.columns = this.columns.map(col => {
        if (this.suppressColumnView && !col.mapping) {
          col.visible = false;
        } else {
          col.visible = true;
        }
        return col;
      });

      // Force a re-render of the table with updated column visibility
      this.$nextTick(() => {
        if (this.$refs.circul8Table) {
          this.$refs.circul8Table.$forceUpdate();
        }

        // After DOM update, recalculate the table height to fill available space
        this.adjustHeight();
      });
    },
    saveFieldConfig() {
      // Get visible column fields based on current checkbox selections
      const visibleFields = this.columns
        .filter(col => col.visible === true)
        .map(col => col.field);

      // Create a storage key that includes import ID and document ID (sheet)
      const storageKey = `raw-data-field-config-${this.customer_id}-import-${
        this.importId
      }-doc-${this.documentSelected?.id || "all"}`;

      // Save to localStorage
      localStorage.setItem(storageKey, JSON.stringify(visibleFields));

      // Force a re-render of the table with only visible columns
      this.$nextTick(() => {
        if (this.$refs.circul8Table) {
          this.$refs.circul8Table.$forceUpdate();
        }

        // After DOM update, recalculate the table height to fill available space
        this.adjustHeight();
      });
    },

    fetchCDFTrasactionData(customer_id) {
      this.isDataLoading = true;
      //here sending true for geting NA values for dropdowns
      this.CDFTransactionDataService.getCdfTransactionField(
        customer_id,
        false
      ).subscribe(
        response => {
          this.cdf_product_sheet = response;
          this.documentSelected = this.allDocumnets.length
            ? this.allDocumnets[0]
            : null;
          this.fileHeaderColumns = [...this.documentSelected.file_headers];
          this.prepareColumns(this.documentSelected);
          this.isDataLoading = false;
        },
        e => {
          console.log(e);
          this.isDataLoading = false;
        }
      );
    },
    fetchCDFProductData(customer_id) {
      this.isDataLoading = true;
      //here sending true for geting NA values for dropdowns
      this.CDFProductDataService.getAll(customer_id, true).subscribe(
        response => {
          this.cdf_product_sheet = response;
          this.documentSelected = this.allDocumnets.length
            ? this.allDocumnets[0]
            : null;
          this.fileHeaderColumns = [...this.documentSelected.file_headers];
          this.prepareColumns(this.documentSelected);
          this.isDataLoading = false;
        },
        e => {
          this.isDataLoading = false;
        }
      );
    },
    mapColumns() {
      this.isMapColumnsActive = true;
    },
    dataManupulation() {
      this.isDataManupulationActive = true;
    },
    updateMapColumns(editedObject) {
      this.isMapColumnsActive = false;
      this.isDataLoading = true; // Add loading state
      // Add this line to ensure editedObject has the isPrimary value
      editedObject.isPrimary = editedObject.isPrimary || false;

      this.DataManagementService.mapRawFilesHeaderData(
        this.documentSelected.id,
        this.customer_id,
        editedObject,
        this.importId
      ).subscribe(
        response => {
          this.$buefy.toast.open({
            message: "CDF mapping updated successfully!",
            type: "is-success"
          });

          if (response && response.length > 0) {
            response[0].is_primary = editedObject.isPrimary;
            // Update the documentSelected with the complete response data
            this.documentSelected = response[0];

            // Also update the document in allDocuments array for consistency
            const index = this.allDocumnets.findIndex(
              doc => doc.id === response[0].id
            );
            if (index !== -1) {
              this.$set(this.allDocumnets, index, response[0]);
            }

            // Update fileHeaderColumns with the fresh data from the response
            this.fileHeaderColumns = [...response[0].file_headers];

            // Re-prepare columns to refresh the table
            this.prepareColumns(response[0]);
          }

          this.isDataLoading = false;
        },
        e => {
          this.isDataLoading = false;
          this.handleApiError(e);
        }
      );
    },
    getAllDocuments() {
      this.DataManagementService.getRawFilesHeaderData(
        this.importId,
        this.customer_id
      ).subscribe(
        response => {
          this.allDocumnets = response;

          // Check if there's a previously selected document for this import
          const lastSelectedDocId = localStorage.getItem(
            `last-selected-document-${this.importId}`
          );

          // If we have a previously selected document, try to select it
          if (lastSelectedDocId && response && response.length) {
            const lastDoc = response.find(
              doc => doc.id.toString() === lastSelectedDocId
            );

            // If found, use it as the selected document
            if (lastDoc) {
              this.documentSelected = lastDoc;
            } else {
              // Otherwise use the first document
              this.documentSelected = response.length ? response[0] : null;
            }
          } else {
            // Default to the first document if no last selected document
            this.documentSelected = response.length ? response[0] : null;
          }

          // Fetch appropriate data based on import type
          if (this?.importData?.import_type === "Transactions") {
            this.fetchCDFTrasactionData(this.importData.customer);
          } else {
            this.fetchCDFProductData(this.importData.customer);
          }
        },
        e => {
          console.log(e);
          // Default to empty array if error occurs
          this.allDocumnets = [];
          this.documentSelected = null;
        }
      );
    },

    getRawFileData(value) {
      this.DataManagementService.getRawFilesHeaderData(
        this.importId,
        this.customer_id
      ).subscribe(
        response => {
          this.allDocumnets = response;
        },
        e => {
          console.log(e);
        }
      );
    },

    openDataCompletionModal() {
      if (this.checkedRow.length || this.isCheckedAll) {
        this.isDataCompletion = true;
      } else {
        this.$buefy.dialog.alert({
          title: "Warning",
          message: "Please choose the record(s) you want to update.",
          confirmText: "Close",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },

    updateColumnWithDataManipulation(columns) {
      this.columns = columns;
      this.isDataManupulationActive = false;
      // Store the current document before making API call
      const currentDocument = this.documentSelected;
      const newColumns = [];
      for (const col of this.columns) {
        // Use either is_editable or isEditable depending on your data
        if (col.is_editable === true) {
          newColumns.push({
            field: col.field,
            field_formula: col.field_formula,
            is_deleted: col.is_deleted
          });
        }
      }

      this.DataManagementService.additionalDataManipulation(
        this.documentSelected.id,
        this.customer_id,
        newColumns
      ).subscribe(
        () => {
          // Success! Now fetch the updated document list
          this.DataManagementService.getRawFilesHeaderData(
            this.importId,
            this.customer_id
          ).subscribe(
            documentsResponse => {
              // Update the document list
              this.allDocumnets = documentsResponse;

              const sameDocumentId = currentDocument.id;
              const sameDocument = documentsResponse.find(
                doc => doc.id === sameDocumentId
              );

              if (sameDocument) {
                // Store the selected document ID to use after data reload
                localStorage.setItem("lastSelectedDocumentId", sameDocumentId);

                // Update document selection first
                this.documentSelected = sameDocument;

                // Clear data
                this.tableData = [];
                this.loadMoreClicked = false;
                this.nextPageCursor = null;
                this.currentPage = 0;
                this.map1 = new Map();
                this.checkedRow = [];
                this.isCheckedAll = false;
                this.checkedData = [];
                this.checkedDataMap = new Map();
                this.nextData = false;

                // Then prepare columns based on this document
                this.prepareColumns(sameDocument);

                // Update file header columns
                if (sameDocument.file_headers) {
                  this.fileHeaderColumns = [...sameDocument.file_headers];
                }
              }
            },
            error => {
              this.handleApiError(error);
              console.error("Error fetching updated documents:", error);
            }
          );
        },
        error => {
          this.handleApiError(error);
          console.error("Error in data manipulation:", error);
        }
      );
    },

    dataCompletionCancel(str) {
      if (str !== "reload") {
        this.reloadProductData();
      }
      this.isDataCompletion = false;
    },
    deleteFile(index) {
      this.addDataDocument.splice(index, 1);
    },
    revertDataCompletionRule(bulkAction) {
      if (bulkAction == "revert") {
        this.$buefy.dialog.confirm({
          title: "Confirmation",
          confirmText: "Yes",
          message:
            "Are you sure you want to revert data completion rule on these records?",
          trapFocus: true,
          onConfirm: value => this.revertDc(value, bulkAction)
        });
      } else {
        this.functionCallingMethod(false, bulkAction);
      }
    },
    revertDc() {
      this.isLoading = true;
      this.tableData = [];
      this.DataManagementService.dataRevert(
        this.importData.customer,
        this.importId
      ).subscribe(() => {
        this.fetchProductTempData(this.stream, this.query);
        this.isLoading = false;
      }, this.handleRevertError);
    },
    fetchAutoValidDropDownVal(customerId) {
      try {
        this.DataManagementService.getProductAutoValidationMsg(
          this.importId,
          customerId
        ).subscribe(
          response => {
            if (this.importType == "Transactions") {
              this.dataValidationDropDownTD = this.prepareDropDownArray(
                response.validation_msg
              );
            } else {
              this.dataValidationDropDownPD = this.prepareDropDownValidationMsgArray(
                response.validation_msg
              );
            }
            this.productFamilyDropDown = this.prepareDropDownArray(
              response.product_family
            );
            this.packagingTypeDropDown = this.prepareDropDownArray(
              response.packaging_type
            );
            this.chemistryDropDown = this.prepareDropDownArray(
              response.chemistry
            );
            this.productGroupDropDown = this.prepareDropDownArray(
              response.product_group
            );
            this.materialDetailDropDown = this.prepareDropDownArray(
              response.material_detail
            );
            this.materialGeneralDropdown = this.prepareDropDownArray(
              response.material_general
            );
          },
          e => {
            console.log(e);
          }
        );
      } catch (e) {
        console.log(e);
      }
    },
    prepareDropDownArray(value) {
      const result = [];
      value.forEach(element => {
        const obj = {};
        obj["name"] = element;
        result.push(obj);
      });
      return result;
    },
    prepareDropDownValidationMsgArray(value) {
      const result = {};
      Object.keys(value).forEach(element => {
        result[element] && result[element].length > 0
          ? ""
          : (result[element] = []);
        value[element].forEach(e => {
          const obj = {};
          obj["name"] = e;
          result[element].push(obj);
        });
      });
      return result;
    },
    getClearFormObject() {
      return {
        customer: null,
        importType: "transaction",
        document: null
      };
    },
    reloadProductData() {
      this.tableData = [];
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.tableData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextData = false;
      this.fetchProductTempData(this.stream, this.query);
      //this.fetchCDFProductData(this.customer_id);
    },
    decodedString(encodedString) {
      // Decode the URL-encoded string
      return decodeURIComponent(encodedString);
    },
    togglePanel() {
      this.isOpen
        ? (this.subHeight = this.subHeight - 215)
        : (this.subHeight = this.subHeight + 215);
      this.checkSize();
      this.adjustHeight();
      return (this.isOpen = !this.isOpen);
    },
    getFileName(file) {
      const cleanFile = file.substring(file.lastIndexOf("/") + 1);
      return this.decodedString(cleanFile);
    },
    functionCallingMethod(value, bulkAction) {
      switch (bulkAction) {
        case "exportProducts":
          this.exportProducts();
          break;
      }
    },
    exportProducts() {
      try {
        const importType = this.importData.import_type;
        if (importType == "Products") {
          this.CDFProductDataService.exportProducts(
            this.customer_id,
            "tempProducts",
            this.stream,
            this.checkedData.map(records => records.id),
            this.totalRecords
          );
        } else {
          this.CDFTransactionDataService.exportTransactions(
            this.customer_id,
            "tempTransactions",
            this.checkedData.map(records => records.id),
            this.totalRecords
          );
        }
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Export is not possible",
          message: e.message
        });
      }
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
    },
    exportAll() {
      this.isLoading = true;
      try {
        const importType = this.importData.import_type;
        if (importType == "Products") {
          this.CDFProductDataService.exportAllProducts(
            this.customer_id,
            "tempProducts",
            this.stream,
            this.query,
            this.totalRecords
          );
        } else {
          this.CDFTransactionDataService.exportAllTransactions(
            this.customer_id,
            "tempTransactions",
            this.query,
            this.totalRecords,
            this.importData.id
          );
        }
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Export is not possible",
          message: e.message
        });
      }
      this.isCheckedAll = false;
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
    },
    additionalBulkCheck(bulkAction) {
      let msg = "";
      if (this.totalRecords < this.exportLargeCount) {
        msg =
          `Are you sure you want to export ` +
          (this?.isCheckedAll
            ? `all`
            : `selected ` + this?.checkedData?.length) +
          ` records?`;
      } else {
        msg =
          `Are you sure you want to export more than ` +
          this.exportLargeCount +
          ` records? Exported file will be sent to your email address`;
      }

      if (this.checkedData.length > 50 || this.isCheckedAll) {
        this.$buefy.dialog.confirm({
          title: "Confirmation",
          confirmText: "Yes",
          message: msg,
          trapFocus: true,
          onConfirm: value => this.exportAll(value, bulkAction)
        });
      } else {
        this.functionCallingMethod(false, bulkAction);
      }
    },
    downloadContent(file) {
      try {
        this.DataManagementService.downloadRawDataFile(
          this.importId,
          this.getFileName(file.document)
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Download Error !",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    editConfirm() {
      this.isModalActive = false;
      this.getCustomerById();
      //this.$router.go();
    },
    editCancel() {
      this.isModalActive = false;
    },
    viewModal(editObject) {
      this.action = "View";
      this.editObject = editObject;
      this.checkDependency(editObject);
      this?.importData?.import_type == "Transactions"
        ? (this.isModalActive = false)
        : (this.isModalActive = true);
    },
    editModal(editObject) {
      this.editObject = editObject;
      this.checkDependency(editObject);
      this.action = "Edit";
      this?.importData?.import_type == "Transactions"
        ? (this.isModalActive = false)
        : (this.isModalActive = true);
    },
    find_column_index(column_name) {
      return this.columns.findIndex(col => col.field === column_name);
    },
    pushValueToColumn(index, column_name, flag) {
      this.columns[index]["allStatusVals"] = [];
      if (
        flag == "materialDetail" &&
        this.materialDetail[`${column_name}`] &&
        this.materialDetail[`${column_name}`].length > 0
      ) {
        for (const element of this.materialDetail[`${column_name}`]) {
          this.columns[index]["allStatusVals"].push({
            name: element
          });
        }
      }
      if (
        flag == "productFamily" &&
        this.productFamily[`${column_name}`] &&
        this.productFamily[`${column_name}`].length > 0
      ) {
        for (const element of this.productFamily[`${column_name}`]) {
          this.columns[index]["allStatusVals"].push({
            name: element
          });
        }
      }
    },
    checkDependency(item) {
      const ProductFamilyIndex = this.find_column_index("product_family");
      if (ProductFamilyIndex > 0) {
        this.pushValueToColumn(
          ProductFamilyIndex,
          item.product_group,
          "productFamily"
        );
      }
      const materialDetailIndex = this.find_column_index("material_detail");
      if (materialDetailIndex > 0) {
        this.pushValueToColumn(
          materialDetailIndex,
          item.material_general,
          "materialDetail"
        );
      }
    },
    viewConfirmExport() {
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isBulkExportModal = false;
    },
    viewCancel() {
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isBulkExportModal = false;
    },
    updatedSingleProduct(editedObject) {
      this.DataManagementService.getOrUpdateProductData(
        this.customer_id,
        this.stream,
        this.$route.params.id,
        "isTemp",
        "",
        editedObject,
        true
      ).subscribe(response => {
        this.$buefy.toast.open({
          message: "Data is updated successfully!",
          type: "is-success"
        });
        this.fetchCDFImportData();
        this.isModalActive = false;
      }, this.handleApiError);
    },

    updateImportStatus(value) {
      this.DataManagementService.updateImportStatus(
        this.customer_id,
        this.importId,
        value
      ).subscribe(
        response => {
          this.fetchCDFImportData();
        },
        e => {
          console.log(e);
        }
      );
    },
    changeDocument(value) {
      this.tableData = [];
      this.totalRecords = 0;
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextData = false;

      // Clear the table data without reload
      if (this.$refs.circul8Table) {
        this.$refs.circul8Table.clearDataWithoutReload();
      }

      // Update the selected document
      this.documentSelected = value;

      // Store the selected document ID in localStorage for persistence
      if (value && value.id) {
        localStorage.setItem(
          `last-selected-document-${this.importId}`,
          value.id.toString()
        );
      }

      // Prepare columns using the document-specific configuration
      this.prepareColumns(value);

      // Update file headers
      if (value && value.file_headers) {
        this.fileHeaderColumns = [...value.file_headers];
      } else {
        this.fileHeaderColumns = [];
      }
    },

    pullNextPage() {
      this.previousData = true;
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;
      const temp = this.nextPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      // remove the duplicate query params
      // query_part = [...new Set(query_part)];
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query =
          query_part.join("&") + "&page=" + (this.currentPage + 1) + "&";
        this.query = "&" + this.query;
        this.getDetailDocumetData(this.query, "next");
      }
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;
      const temp = this.PreviousPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      if (this.currentPage == 0 || this.currentPage == 1) {
        this.query = query_part.join("&") + "&page=1&";
        this.previousData = false;
      } else {
        this.query = query_part.join("&") + "&page=" + this.currentPage + "&";
      }
      this.query = "&" + this.query;
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.getDetailDocumetData(this.query, "prev");
    },
    prepareColumns(doc) {
      if (!doc || !doc.file_headers) {
        this.isDataLoading = false;
        return;
      }
      this.isDataLoading = true;
      this.columns = [];
      this.tableData = [];
      // Create a storage key that includes import ID and document ID (sheet)
      const storageKey = `raw-data-field-config-${this.customer_id}-import-${
        this.importId
      }-doc-${doc?.id || "all"}`;

      // Get saved configuration using the new key format
      let savedConfig = localStorage.getItem(storageKey);

      // If no saved config is found for this specific import and document, check for customer-level config (for backward compatibility)
      if (!savedConfig) {
        savedConfig = localStorage.getItem(
          `raw-data-field-config-${this.customer_id}`
        );
      }

      // Parse the saved configuration if it exists
      const savedFieldConfig = savedConfig ? JSON.parse(savedConfig) : null;

      // Add columns with default visibility set to true
      (doc.file_headers || []).forEach(e => {
        if (!e.field_error) {
          let visible = true; // Default to visible

          // If we have a saved configuration, use it to determine visibility
          if (savedFieldConfig) {
            // For array format (new format)
            if (Array.isArray(savedFieldConfig)) {
              visible = savedFieldConfig.includes(e.field);
            }
            // For object format (old format)
            else {
              visible = savedFieldConfig[e.field] !== false;
            }
          }

          this.columns.push({
            field: e.field,
            label:
              e.label +
              (e.mapping
                ? `<span class='mapping-grey'> (${e.mapping.name})</span>`
                : ""),
            mapping: e.mapping, // ensure mapping is always boolean
            isEditable: e.is_editable,
            field_formula: e.field_formula,
            searchable: true,
            filterKey: [],
            type: e.type,
            width: "250",
            visible: visible
          });
        }
      });

      this.columns.push({
        field: "actions",
        label: "",
        headerClass: "is-actions",
        cellClass: "is-actions",
        visible: true,
        searchable: true,
        type: "actionSearch",
        actionSearch: true,
        filterKey: { actions: "" }
      });
      this.getDetailDocumetData();
    },
    getDetailDocumetData(query = "", scrollDir) {
      this.isDataLoading = true;
      this.DataManagementService.getRawFileData(
        this.customer_id,
        this.documentSelected.id,
        query
      ).subscribe(
        response => {
          if (response["results"]) {
            this.PreviousPageCursor = this.nextPageCursor
              ? this.nextPageCursor
              : this.PreviousPageCursor;
            this.nextPageCursor = response["next"];
            if (this.currentPage > 1) {
              this.previousData = true;
              if (this.nextPageCursor != null) {
                this.enableLoadMore = this.nextData = true;
              } else {
                this.enableLoadMore = this.nextData = false;
              }
            } else {
              this.enableLoadMore = this.previousData = false;
              if (this.nextPageCursor != null) {
                this.enableLoadMore = this.nextData = true;
              } else {
                this.enableLoadMore = this.nextData = false;
              }
            }
            this.totalRecords = response["count"];
            let tempData = [];
            if (scrollDir == "next") {
              if (!this.nextPageCursor) {
                this.prepareData(response["results"]);
              } else {
                tempData = [...this.tableData, ...response["results"]];
                if (tempData.length > 100 && this.nextPageCursor != null) {
                  tempData = tempData.slice(50, 150);
                }
                this.prepareData(tempData);
              }
            } else if (scrollDir == "prev") {
              if (this.currentPage == 0) {
                this.prepareData(response["results"]);
              } else {
                tempData = [...response["results"], ...this.tableData];
                if (tempData.length >= 100) {
                  tempData = tempData.slice(0, 100);
                }
                this.prepareData(tempData);
              }
            } else {
              this.prepareData(response["results"]);
            }
          } else {
            this.prepareData(response);
          }
          this.isDataLoading = false;
        },
        e => {
          this.isDataLoading = false;
        }
      );
    },

    prepareData(data) {
      const dataList = [];
      for (const report in data) {
        const reportData = data[report];
        reportData["updated_at"] = this.dateToLocalDate(
          reportData["updated_at"]
        );
        reportData["created_at"] = this.dateToLocalDate(
          reportData["created_at"]
        );
        if (reportData["dc_created_at"]) {
          reportData["dc_created_at"] = this.dateToLocalDate(
            reportData["dc_created_at"]
          );
        }

        reportData["actions"] = "true";
        dataList.push(reportData);
      }

      if (this.nextPageCursor == null) {
        this.tableData.push(...dataList);
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        this.tableData = dataList;
      }
      //if select all checkbox clicked the show all the data for the page as checked
      if (this.isCheckedAll) {
        this.checkedRow = this.tableData;
      } else {
        //else show the corresponding data from the dictionay map1
        const temp = [];
        // check if dictionary has value or not
        if (
          this.map1.get(this.currentPage) &&
          this.map1.get(this.currentPage).length > 0
        ) {
          //inserting data according to index of the current page
          this.map1.get(this.currentPage).forEach(element => {
            temp.push(this.tableData[element]);
          });
          this.checkedRow = temp;
        } else {
          this.checkedRow = [];
        }
      }
      this.checkSize();
      this.adjustHeight();
      this.isDataLoading = false;
    },

    fetchRawImportDataById() {
      this.isDataLoading = true;
      this.currentPage = 0;
      this.DataManagementService.getImportedRawDataById(
        this.importId
      ).subscribe(
        response => {
          this.importData = response;
          this.customer_id =
            this.importData?.customer?.id ?? this.importData?.customer;
          this.parent_customer_id =
            this.importData?.parent_customer?.id ??
            this.importData?.parent_customer;
          if (this.importData?.status != "Completed and Validated") {
            this.getAllDocuments();
          }
          this.isDataLoading = false;
        },
        e => {
          this.isDataLoading = false;
        }
      );
    },
    showComments(value) {
      this.$buefy.dialog.alert({
        title: "Comments",
        message: value,
        confirmText: "Close",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },

    handleApiError(reason) {
      let errorMessage = null;
      if (reason?.response?.data) {
        if (reason.response.data["detail"]) {
          errorMessage = reason.response.data["detail"];
        } else if (reason.response.data["error"]) {
          errorMessage = reason.response.data["error"];
        } else if (reason.response.data["name"]) {
          errorMessage = reason.response.data["name"];
        } else {
          errorMessage = "Some issue while updating status";
        }
      }
      this.isLoading = false;
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },
    handleRevertError(reason) {
      let errorMessage = reason.response.data["detail"];
      this.isLoading = false;
      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Some issue while updating status";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
      this.fetchProductTempData(this.stream, this.query);
    },

    validateData() {
      this.isCardModalActive = false;
      this.DataManagementService.validateOrDiscardRawData(
        this.importId,
        this.customer_id,
        this.tempWorkflowStatus
      ).subscribe(response => {
        this.$buefy.toast.open({
          message: "Status updated Successfully",
          type: "is-success"
        });
        this.routeToRespectivePage(this.importType);
      }, this.handleApiError);
    },

    validateDataConfirm() {
      if (this.tempWorkflowStatus == ImportCDFWorkflowStatus.DISCARDED) {
        this.$buefy.dialog.confirm({
          title: "Confirmation",
          confirmText: "Yes",
          message: `All imported data will be erased, do you want to continue ?`,
          trapFocus: true,
          onConfirm: value => this.validateData()
        });
      } else {
        this.validateData();
      }
    },

    backToImport() {
      this.$router.push({
        name: "datamanagement.importRawData"
      });
    },
    tempStatusChange() {
      this.validateDataConfirm();
    },
    checkedAllData(value) {
      this.isCheckedAll = value;
      if (!this.isCheckedAll) {
        this.checkedRow = [];
        this.map1 = new Map();
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
      } else {
        this.checkedDataMap.set(this.currentPage, this.tableData);
      }
    },
    checkCheckBox(d) {
      // select all should be false now
      const total_checked = this.checkedData.length;
      const indexes = [];
      //getting the index of the checked rows
      d.forEach(element => {
        const index = this.tableData.findIndex(object => {
          return element.id === object.id;
        });
        indexes.push(index);
      });
      // create 2 dictionary. one with indexes for showing current page selected another with checked row value
      this.map1.set(this.currentPage, indexes);

      if (d.length > 0) {
        this.checkedDataMap.set(this.currentPage, d);
      } else {
        !this.isCheckedAll && this.checkedDataMap.set(this.currentPage, d);
      }
      this.checkedRow = d;
      this.checkedData = [];
      // converting mapped data into array for bulk operations
      this.checkedDataMap.forEach(element => {
        this.checkedData.push(...element);
      });
      // if checked all is true and deselect any
      if (this.isCheckedAll && total_checked > this.checkedData.length) {
        this.isCheckedAll = false;
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
        this.map1 = new Map();
      }
    },
    searchByFilter(filterQuery) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.tableData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextData = false;
      this.query = "&" + filterQuery;
      //      this.displayedRecords = 0;

      let query = "";
      // Maintaining sort column & order in separate varaibles instead of this.query as it becomes difficult to replace & maintain
      // sort column & order part of this.query string. We should maintain query params in associative array instead of string
      if (this.lastSortColumn) {
        query += "&order_field" + "=" + this.lastSortColumn + "&";
        query += "&order_by" + "=" + this.lastSortOrder + "&";
        query += this.query;
      } else {
        query = this.query;
      }
      //if (this?.importData?.import_type == "Transactions") {
      this.getDetailDocumetData(query);
      //}
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.nextData = false;
      this.currentPage = 0;
      this.tableData = [];
      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");

      const oldOrderField = "&order_field" + "=" + this.lastSortColumn + "&";
      const oldOrderValue = "&order_by" + "=" + this.lastSortOrder + "&";
      const newOrderField = "&order_field" + "=" + field + "&";
      const newOrderValue = "&order_by" + "=" + order + "&";

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      //     this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.getDetailDocumetData(this.query);
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },

    checkCurrentStatus(value) {
      if (this.importData?.status === value) {
        return true;
      }
      return false;
    },

    routeToRespectivePage(importType) {
      const routeName = "datamanagement.importRawData";
      const routeCustomer =
        this.parent_customer_id != null
          ? this.parent_customer_id
          : this.customer_id;
      this.$router.push({
        name: routeName,
        params: {
          customerId: routeCustomer
        }
      });
    },

    routeToImport() {
      this.$router.push({
        name: "datamanagement.import"
      });
    },

    checkSize() {
      screenPixelSize = screen.width;
      pixelRatio =
        window.devicePixelRatio ||
        window.screen.availWidth / document.documentElement.clientWidth;
      pixelRatio = pixelRatio.toFixed(1);
      if (
        (screenPixelSize > 1024 &&
          screenPixelSize < 1281 &&
          pixelRatio == 1.5) ||
        (screenPixelSize > 1580 && screenPixelSize < 1921 && pixelRatio == 1.5)
      ) {
        this.subHeight = this.subHeight - 15;
      }

      // Add this guard:
      if (!this.$refs.circul8Table) return;

      this.$refs.circul8Table.$refs.multiselect &&
        this.$refs.circul8Table.$refs.multiselect.forEach(element => {
          element.deactivate();
        });
      this.$refs.circul8Table.$refs.dropdown &&
        this.$refs.circul8Table.$refs.dropdown.forEach(element => {
          element.isActive = false;
        });
      this.$refs.circul8Table.$refs.datePicker &&
        this.$refs.circul8Table.$refs.datePicker.forEach(element => {
          element.closePopup();
        });
    },

    adjustHeight() {
      const browser_height = window.innerHeight;
      const newTableHeight = browser_height - this.subHeight;
      const tableWrapper = document.querySelector(".table-wrapper");
      if (tableWrapper) {
        tableWrapper.style.maxHeight = newTableHeight + "px";
      }
    },
    submit() {
      this.DataManagementService.addMoreData(
        this.importData.id,
        this.importData.import_type,
        this.customer_id,
        this.addDataDocument
      ).subscribe(() => {
        this.$buefy.dialog.confirm({
          title: "Success",
          message: "Import triggered successfully.",
          onConfirm: this.routeToImport()
        });
        this.isNewDataFileListActive = false;
      }, this.handleApiError);
    }
  }
};
</script>
